import { Button, Card, CircularProgress, Grid, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { RichTextEditor } from '../../../../../matx';
import { UploadImage } from '../../../../components';
import { addDataKarir, getDepartementKarir } from '../../../../redux/actions/KarirActions';

const TambahData = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);
    const { departement } = useSelector(
        ({ karir }) => karir
    );
    const [params, setParams] = useState({
        d_code:"",
        placement:"",
        title_id:"",
        title_en:"",
        overview_id:"",
        overview_en:"",
        job_desc_id:"",
        job_desc_en:"",
        qualification_id:"",
        qualification_en:"",
        benefit_id:"",
        benefit_en:"",
        type:"",
        bg_desktop:"",
        bg_desktop_preview:"",
        bg_mobile:"",
        bg_mobile_preview:"",
        subject_email:"",
        bg_cta:"",
        bg_cta_preview:"",
    });
    useEffect(() => {
      dispatch(getDepartementKarir({paginate: false}))
    }, [dispatch])
    
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        addDataKarir(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    };
    const handleChangeFoto = (name, file) => {
        setParams((pref) => ({
            ...pref,
            [name]: file,
            [name+'_preview']: file
        }));
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Tambah Karir</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        <ValidatorForm
                            onSubmit={handleFormSubmit}
                            className="w-full"
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("bg_desktop", file)}
                                        label="Unggah Foto Desktop"
                                        preview={
                                            params?.bg_desktop_preview
                                        }
                                        required={true}
                                        noCrop
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 1440 x 617'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("bg_mobile", file)}
                                        label="Unggah Foto Mobile"
                                        preview={
                                            params?.bg_mobile_preview
                                        }
                                        required={true}
                                        noCrop
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 767 x 500'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="title_id"
                                        className="mb-4"
                                    >
                                        Lowongan [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="title_id"
                                        placeholder="Lowongan"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="title_id"
                                        value={params.title_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Lowongan terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="title_en"
                                        className="mb-4"
                                    >
                                        Lowongan [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="title_en"
                                        placeholder="Lowongan"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="title_en"
                                        value={params.title_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Lowongan terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel htmlFor="d_code" className="mb-4">
                                        Departement{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <Select
                                        size="small"
                                        labelId="d_code"
                                        value={params.d_code}
                                        onChange={handleChange}
                                        variant="outlined"
                                        className="w-full"
                                        name="d_code"
                                        displayEmpty
                                    >
                                        <MenuItem value="" selected>
                                            Pilih Departement
                                        </MenuItem>
                                        {departement?.map((item) => (
                                            <MenuItem
                                                value={item.d_code}
                                                key={item.d_code}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel htmlFor="type" className="mb-4">
                                        Waktu Kerja{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <Select
                                        size="small"
                                        labelId="type"
                                        value={params.type}
                                        onChange={handleChange}
                                        variant="outlined"
                                        className="w-full"
                                        name="type"
                                        displayEmpty
                                    >
                                        <MenuItem value="" selected>
                                            Pilih Waktu Kerja
                                        </MenuItem>
                                        <MenuItem value="fulltime" selected>
                                            Full Time
                                        </MenuItem>
                                        <MenuItem value="internship" selected>
                                        Internship
                                        </MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel htmlFor="placement" className="mb-4">
                                        Lokasi Kerja{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <Select
                                        size="small"
                                        labelId="placement"
                                        value={params.placement}
                                        onChange={handleChange}
                                        variant="outlined"
                                        className="w-full"
                                        name="placement"
                                        displayEmpty
                                    >
                                        <MenuItem value="" selected>
                                            Lokasi Kerja
                                        </MenuItem>
                                        <MenuItem value="onsite" selected>
                                        On-site
                                        </MenuItem>
                                        <MenuItem value="remote" selected>
                                        Remote
                                        </MenuItem>
                                        <MenuItem value="hybrid" selected>
                                        Hybrid
                                        </MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="overview_id"
                                        className="mb-4"
                                    >
                                        Deskripsi Singkat [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="overview_id"
                                        placeholder="Deskripsi Singkat"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="overview_id"
                                        value={params.overview_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi Singkat terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={10}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="overview_en"
                                        className="mb-4"
                                    >
                                        Deskripsi Singkat [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="overview_en"
                                        placeholder="Deskripsi Singkat"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="overview_en"
                                        value={params.overview_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi Singkat terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={10}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="job_desc_id"
                                        className="mb-4"
                                    >
                                        Deskripsi Pekerjaan [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, job_desc_id: content}))} content={params.job_desc_id} placeholder="Ketik deskripsi pekerjaan disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="job_desc_en"
                                        className="mb-4"
                                    >
                                        Deskripsi Pekerjaan [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, job_desc_en: content}))} content={params.job_desc_en} placeholder="Ketik deskripsi pekerjaan disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="qualification_id"
                                        className="mb-4"
                                    >
                                        Kualifikasi [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, qualification_id: content}))} content={params.qualification_id} placeholder="Ketik kualifikasi disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="qualification_en"
                                        className="mb-4"
                                    >
                                        Kualifikasi [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, qualification_en: content}))} content={params.qualification_en} placeholder="Ketik kualifikasi disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="benefit_id"
                                        className="mb-4"
                                    >
                                        Benefit/Keuntungan [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, benefit_id: content}))} content={params.benefit_id} placeholder="Ketik kualifikasi disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="benefit_en"
                                        className="mb-4"
                                    >
                                        Benefit/Keuntungan [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, benefit_en: content}))} content={params.benefit_en} placeholder="Ketik kualifikasi disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="subject_email"
                                        className="mb-4"
                                    >
                                        Subjek Email [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="subject_email"
                                        placeholder="Subjek Email Saat Melamar Kerja"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="subject_email"
                                        value={params.subject_email || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Subjek Email Saat Melamar Kerja terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("bg_cta", file)}
                                        label="Background Foto CTA"
                                        preview={
                                            params?.bg_cta_preview
                                        }
                                        required={true}
                                        noCrop
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 1440 x 550'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent="flex-end"
                                        className="flex-column-reverse flex-md-row"
                                    >
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                color="primary"
                                                className="text-primary w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                                onClick={() => history.goBack()}
                                            >
                                                Batal
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="text-white w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                            >
                                                {submit ? (
                                                    <CircularProgress
                                                        color="primary"
                                                        size={25}
                                                    />
                                                ) : (
                                                    'Simpan'
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default TambahData;
